
import { IconComponents } from "components/Icon";
import "./Menu.css";
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import React, { useContext, useEffect, useState } from "react";
import MenuItems from "./MenuItem";
import { IMenuItem } from "./MenuProps";
import { ProviderLayout } from "view/ExampleLayout/Admin";


const MenuItemCollapse = (props: IMenuItem) => {

    const {
        IsMenuOpen,
        IsOverMouse,
        arrMenuOpen,
        handleClickMenuOpen
    } = useContext(ProviderLayout);

    const [IsOpenCollape, setIsOpenCollape] = useState(false);

    const handleClick = () => {
        setIsOpenCollape(!IsOpenCollape);
    };

    const MenuSpace = () => {
        let nLevel = !IsMenuOpen && !IsOverMouse ? 1 : props.nLevel;
        return nLevel * 16 + "px";
};

    useEffect(() => {
        if (!IsMenuOpen) {
            setIsOpenCollape(false)
        }
    }, [IsMenuOpen])


    useEffect(() => {
        if (IsOverMouse || IsMenuOpen) {
            let checkOpen = arrMenuOpen.indexOf(props.nMenuID);
            setIsOpenCollape(checkOpen !== -1)
        }
    }, [arrMenuOpen, IsOverMouse, props.nMenuID, IsMenuOpen])

    return <React.Fragment>
       <Tooltip title={props.sMenuName} placement="right">
        <ListItemButton onClick={() => { handleClick(); handleClickMenuOpen(props.nMenuID) }} className={`nav-menu-itemH nav-menu-itemH-lv` + props.nLevel} sx={{ pl: MenuSpace() }}>
            <ListItemIcon sx={{ ml: '2px' }}>
                {IconComponents(props.sIcon)}
            </ListItemIcon>
            <ListItemText primary={props.sMenuName} primaryTypographyProps={{ style: { whiteSpace: "nowrap",overflow:'hidden',textOverflow:'ellipsis' } }}/>
                {IsOpenCollape ? <ExpandLess style={{ display: IsMenuOpen ? "" : "none" }} /> : <ExpandMore style={{ display: IsMenuOpen ? "" : "none" }} />}
        </ListItemButton>
    </Tooltip> 
        <Collapse key={`nav-menu-item-collapse-` + props.nMenuID} in={IsOpenCollape} timeout="auto" unmountOnExit className="nav-menu-item-collapse">
            <List component="div" disablePadding>
                {props.lstChildrenMenu.map((item, index) => {
                    return item.lstChildrenMenu.length > 0 ?
                        (
                            <MenuItemCollapse key={item.nMenuID} {...item} />
                        ) :
                        (
                            <MenuItems key={item.nMenuID} {...item} />
                        )
                })}
            </List>
        </Collapse>
    </React.Fragment>
}
export default MenuItemCollapse;
